import { render, staticRenderFns } from "./major_customer.vue?vue&type=template&id=1b3a08f5&scoped=true&"
import script from "./major_customer.vue?vue&type=script&lang=js&"
export * from "./major_customer.vue?vue&type=script&lang=js&"
import style0 from "./major_customer.vue?vue&type=style&index=0&id=1b3a08f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a08f5",
  null
  
)

export default component.exports